export const hasMeaningfulAiDisplayString = (value) => {
    if (value == null || typeof value !== 'string') return false;
    const t = value.trim();
    if (t === '') return false;
    const lower = t.toLowerCase();
    if (lower === 'null' || lower === 'undefined') return false;
    return true;
};

export const stripTagsForPrint = (input) => {
    if (!input) return '';
    let stripped = String(input).replace(/<[^>]*>?/gm, '');
    stripped = stripped.replace(/```html|```|\*\*/g, '');
    return stripped.trim();
};

export const getQuestionAiPrintData = (questionIndex, aiGrades, aiFeedbacks, aiSuggestions) => {
    const aiGrade = Array.isArray(aiGrades) ? aiGrades[questionIndex] : null;
    const aiFeedback = Array.isArray(aiFeedbacks) ? aiFeedbacks[questionIndex] : null;
    const aiSuggestion = Array.isArray(aiSuggestions) ? aiSuggestions[questionIndex] : null;

    const gradeFeedback = aiGrade?.ai_grade_feedback;
    let errorsHtml = hasMeaningfulAiDisplayString(aiFeedback) ? aiFeedback : null;
    let explanationHtml = hasMeaningfulAiDisplayString(gradeFeedback) ? gradeFeedback : null;
    if (
        errorsHtml &&
        explanationHtml &&
        stripTagsForPrint(errorsHtml) === stripTagsForPrint(explanationHtml)
    ) {
        errorsHtml = null;
    }

    const suggestionText = hasMeaningfulAiDisplayString(aiSuggestion) ? aiSuggestion : null;

    const isRubrics = aiGrade?.type === 'rubrics';
    const showGradeScore =
        aiGrade &&
        !isRubrics &&
        (aiGrade.ai_grade_point != null || aiGrade.max_mark_per_question != null);

    const hasContent =
        showGradeScore ||
        isRubrics ||
        Boolean(explanationHtml) ||
        Boolean(errorsHtml) ||
        Boolean(suggestionText);

    if (!hasContent) {
        return null;
    }

    return {
        aiGrade,
        isRubrics,
        showGradeScore,
        explanationHtml,
        errorsHtml,
        suggestionText,
    };
};
